export default [
    {
        // [0]
        key: "name",
        label: app.$i18n.t("Name"),
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "accounting_account",
        label: app.$i18n.t("Accounting account"),
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "created_at",
        label: app.$i18n.t("Created at"),
        sortable: true,
        visible: true,
    },
    {
        // [13]
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]